import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M9 15.75A6.75 6.75 0 0 1 2.25 9v0A6.75 6.75 0 0 1 9 2.25v0A6.75 6.75 0 0 1 15.75 9v0A6.75 6.75 0 0 1 9 15.75",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M9 9.938V9.75c0-.613.379-.945.758-1.2.37-.25.742-.575.742-1.175a1.5 1.5 0 1 0-3 0M9 12a.188.188 0 1 0 .002.375.188.188 0 0 0-.003-.375"
	})]
});
export default SvgHelpinline;
